import React, { useState, useEffect, useRef } from "react";
import { DecryptAESdata } from "../../../provider/ServiceProvider";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import invest from "../../../images/invest.png";
import "./PageDecryptAES.css";
 

function PageDecryptAES() {
  const [encryptedstring, Setencryptedstring] = useState();
  const [decryptedstring, Setdecryptedstring] = useState();
  function sayHello() {
    Setdecryptedstring(JSON.stringify(DecryptAESdata(encryptedstring)));
  }
  const handleMessageChange = event => {
    // 👇️ access textarea value
    Setencryptedstring(event.target.value);
     
  };
  

  return (
    <>
     <div className="divheight">
    <section >
        <Container>
          <Row>
            <Col sm={12}>
              <div className="trending-pnl">
                <div className="section-header">
                  <h2>Decrypt AES Data</h2>
                </div>
                <textarea value={encryptedstring} onChange={handleMessageChange} rows={10} cols={100} />
                <button onClick={sayHello}>Decrypt</button>
                <textarea value={decryptedstring} onChange={handleMessageChange} rows={10} cols={100} />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
     
    </>
  );
}
export default PageDecryptAES;